/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Infinite = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M21.86 9.47C21.41 8.69 20.78 8.08 19.97 7.65C19.16 7.22 18.23 7 17.18 7C16.13 7 15.17 7.29 14.25 7.85C13.74 8.17 13.25 8.57 12.8 9.06L13.75 10.7C14.08 10.31 14.44 9.97 14.81 9.7C15.58 9.14 16.36 8.86 17.18 8.86C18.26 8.86 19.11 9.15 19.73 9.73C20.35 10.32 20.66 11.12 20.66 12.13C20.66 13.14 20.35 13.95 19.73 14.55C19.11 15.14 18.26 15.44 17.18 15.44C16.36 15.44 15.58 15.15 14.81 14.58C14.1 14.06 13.47 13.3 12.92 12.33L12.81 12.13L11.77 10.33H11.76C11.03 9.24 10.21 8.42 9.28 7.85C8.34 7.29 7.37 7 6.36 7C5.35 7 4.37 7.22 3.56 7.65C2.75 8.08 2.12 8.69 1.67 9.47C1.22 10.25 1 11.14 1 12.13C1 13.12 1.22 14.02 1.67 14.8C2.12 15.58 2.75 16.19 3.56 16.62C4.37 17.05 5.31 17.26 6.36 17.26C7.41 17.26 8.34 16.99 9.26 16.43C10.19 15.87 11.02 15.04 11.77 13.94C12.51 15.04 13.34 15.87 14.27 16.43C15.19 16.99 16.16 17.26 17.18 17.26C18.2 17.26 19.16 17.05 19.97 16.62C20.78 16.19 21.41 15.58 21.86 14.8C22.31 14.02 22.54 13.13 22.54 12.13C22.54 11.13 22.31 10.25 21.86 9.47ZM8.74 14.58C7.98 15.15 7.19 15.44 6.36 15.44C5.25 15.44 4.4 15.14 3.79 14.55C3.18 13.95 2.88 13.15 2.88 12.13C2.88 11.11 3.18 10.32 3.79 9.73C4.4 9.15 5.25 8.86 6.36 8.86C7.17 8.86 7.96 9.14 8.73 9.7C9.5 10.25 10.17 11.07 10.75 12.13C10.17 13.2 9.5 14.02 8.74 14.58Z"
                        fill={color}
                    />
                </svg>
        );
    };
